module.exports = __webpack_public_path__ + "static/img/jp0.c883c598.png";